import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import MultiListSearch from '../../search/MultiListSearch';

export default props => {
  return <FormInputSearch {...props} searchComponent={MultiListSearch} />;
};
